import { Get } from '../fetch';
import { urls } from '../constants';
export async function getSubscriptionPlans() {
  return Get(urls.subscriptions.billing.plans.v1);
}
export async function getSubscriptionPlan(planId) {
  return Get(`${urls.subscriptions.billing.plans.v1}/${planId}`);
}